const HOME = "/";
const VIDEOS = "/videos";
const PICS = "/pics";
const CALENDAR = "/calendar";
const ABOUT = "/about";
const CONTACT = "/contact";

const MUSIC = "/music";
const MUSIC_NORTON = "/norton-think-about-nothing";
const MUSIC_I_WILL_TELL_YOU = "/i-will-tell-you";
const MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR = "/christmas-songs-on-bass-guitar";

const route = {
  HOME,
  VIDEOS,
  PICS,
  CALENDAR,
  ABOUT,
  CONTACT,
  MUSIC,
  MUSIC_NORTON,
  MUSIC_I_WILL_TELL_YOU,
  MUSIC_CHRISTMAS_SONGS_ON_BASS_GUITAR
};

export default route;



// WEBPACK FOOTER //
// ./src/routes/ROUTE_CONSTANTS.js